export const EventName = {
  Modal: 'Wantquotes_Modal',
  Download_Button: 'Wantquotes_Download_Button',
  Modal_NotTips: 'Wantquotes_Modal_NotTips',
  Modal_Close: 'Wantquotes_Modal_Close',
}

export const buryingPoint = (data) => {
  const { t = 'pv', name = '', options = {} } = data || {};

  function log(url) {
    const img = new Image();
    img.src = url;
  }

  const params = {
    ua: window.navigator?.userAgent,
    page: window.location.href,
    // @ts-ignore
    ct: window.navigator?.connection?.effectiveType,
    t, // 事件类型
    name, // 事件名
    ts: Date.now(), // 时间戳
    options: JSON.stringify(options), // 事件参数
  };

  // 将对象转换为 key=value 的字符串
  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');

  const url = `/1x1.gif?${queryString}`;

  log(url);
};
